import {useQuery} from '@tanstack/react-query';
import api from '../../util/api.js';

export const usePosts = (opt={})=>{
    let {data, isLoading} = useQuery({
        queryKey: ['blog_posts', opt],
        queryFn: ()=>api.blog.getPosts(opt),
    });
    return [data?.posts, isLoading];
};

export const useSearchPosts = (opt={})=>{
    let {data, isLoading} = useQuery({
        queryKey: ['blog_posts_search', opt],
        queryFn: ()=>api.blog.searchPosts(opt),
    });
    return [data?.posts, isLoading];
};

export const usePost = (slug, preview)=>{
    let {data, isLoading} = useQuery({
        queryKey: ['blog_post', slug, preview],
        queryFn: ()=>api.blog.getPost(slug, preview),
        enabled: !!slug,
    });
    return [data?.post, isLoading];
};

export const useTags = ()=>{
    let {data, isLoading} = useQuery({
        queryKey: ['blog_tags'],
        queryFn: ()=>api.blog.getTags(),
    });
    return [data?.tags?.data, isLoading];
};

export const useCategories = ()=>{
    let {data, isLoading} = useQuery({
        queryKey: ['blog_cats'],
        queryFn: ()=>api.blog.getCategories(),
    });
    return [data?.categories?.data, isLoading];
};
